import { createPathname } from '@reward-platform/utils'

export const AUTH_PATHS = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  CALLBACK: '/auth/callback',
  PROFILE: '/auth/me',
} as const

export type AuthPathKey = keyof typeof AUTH_PATHS

export type AuthPathOptions = {
  basePath?: string
  returnToPath?: string
  returnToLocale?: string
}

export const createAuthPathname = (
  type: AuthPathKey,
  { basePath, returnToPath, returnToLocale }: AuthPathOptions = {}
) => {
  const authPath = createPathname(AUTH_PATHS[type], basePath)
  let returnTo = returnToPath && createPathname(returnToPath, basePath, returnToLocale)
  if (type === 'LOGOUT') {
    const { origin } = window.location
    returnTo = `${origin}${createPathname('/', basePath, returnToLocale)}`
  }
  const returnToQuery = returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ''

  return `${authPath}${returnToQuery}`
}
